import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	selector: 'ms-dialog-error',
	templateUrl: './ms-dialog-error.component.html',
	styleUrls: ['./ms-dialog-error.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsDialogErrorComponent implements OnInit, OnDestroy {
	data: any;

	/**
	 * Constructor
	 */
	constructor(
		private _dynamicDialogRef: DynamicDialogRef,
		private _dynamicDialogConfig: DynamicDialogConfig
	) {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.data = this._dynamicDialogConfig.data;
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------
	onClose(): void {
		this._dynamicDialogRef.close();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
